import React, { useEffect, useState } from "react";
import { store } from "react-notifications-component";

interface IProps {
  info: string[] | null;
  onHide: Function;
}

const InfoAlerts: React.FC<IProps> = ({ info, onHide }: IProps) => {
  const [infoAlertDisplayed, setInfoAlertDisplayed] = useState(false);

  useEffect(() => {
    const infoNotifications = () => {
      const infoText = info?.reduce((acc: string, item: string) => `${acc} ${item}`, "");
      if (!infoAlertDisplayed) {
        store.addNotification({
          title: "Informacja!",
          message: infoText,
          type: "info",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
            showIcon: true,
          },
          onRemoval: () => {
            onHide();
            setInfoAlertDisplayed(false);
          },
        });
        setInfoAlertDisplayed(true);
      }
    };

    if (info) {
      infoNotifications();
    }
    //eslint-disable-next-line
  }, [info]);
  return <React.Fragment></React.Fragment>;
};

export default InfoAlerts;
